<template>
  <b-row class="rowbg">
    <b-col md="12">
      <b-card>
        <b-card-title>het Pepernotenlied!</b-card-title>
        <b-card-text>
          <b-img
            fluid
            align="right"
            class="w-50 cardimage"
            v-bind:src="
              $imagestore2 + 'images/artikelen/pepernoten2022.jpg'
            "
          />
          <p>Strooien hoort erbij en met dit lied wordt het nog gezellig! Zing jij met ons mee? Olé!
          </p>
        </b-card-text>
      </b-card>

      <b-card>
        <b-card-title>Pakjesavond!?</b-card-title>
        <b-card-text>
          <b-img
            fluid
            align="right"
            class="w-50 cardimage"
            v-bind:src="
              $imagestore2 + 'images/artikelen/website_pakjesavond2022.png'
            "
          />
          <p>
            Wij komen langs! Voor een geweldige pakjesavond kun je Piet&Piet of
            Piet&Sint uitnodigen om te dansen, zingen en pepernoten te strooien.
          </p>
          <p>
            Neem contact op via ons contactformulier, we proberen dan zo snel
            mogelijk te laten weten of jouw aanvraag mogelijk is.
          </p>
        </b-card-text>
      </b-card>

      <b-card>
        <b-card-title>Nóg groter team</b-card-title>
        <b-card-text>
          <b-img
            fluid
            align="right"
            class="w-50 cardimage"
            v-bind:src="
              $imagestore2 + 'images/artikelen/teamfoto_vraagteken3.png'
            "
          />
          <p>
            We maakten al bekend dat de bezetting van 2021 groter werd. Maar we
            mogen nu melden dat we daar nog een schepje bovenop doen. Vanaf 1
            mei komt ook Kristel de Groot het team versterken!.
          </p>
          <p>
            Naast Pieter, Jos, Yorick en Ludo is Kristel de lijm, het geweten en
            de vragensteller. Hiermee is het team van Ridder en de Prins écht
            compleet en kunnen we vol energie weer honderden kinderen verassen
            met onze aanwezigheid.
          </p>
        </b-card-text>
      </b-card>

      <b-card>
        <b-card-title>Ridder en de Prins 2021</b-card-title>
        <b-card-text>
          <b-img
            fluid
            align="right"
            class="w-50 cardimage"
            v-bind:src="
              $imagestore1 + '/website%202018/Ridder-en-de-Prins-Teamfoto.png'
            "
          />
          <p>
            Het Sinterklaasseizoen van 2021 nadert alweer met rasse schreden!
            Hoewel nog niks zeker is zijn we bij Ridder en de Prins ervan
            overtuigd dat we deze winter weer samen Sinterklaas kunnen vieren.
            Vol verwachting klopt ons hart met de komst van Sint en Piet in
            november! Met trots stellen wij jullie op de hoogte van enkele
            veranderingen binnen ons mooie bedrijf.
          </p>
          <p>
            Na het met veel plezier draaien van maar liefst negen succesvolle
            seizoenen neemt Remco afscheid van Ridder en de Prins. Onze Sint en
            Piet hadden daarin 1062 boekingen, dat was nooit kwalitatief gelukt
            zonder zijn inzet. We willen hem bedanken voor zijn onvermoeibare
            inspanningen om Ridder en de Prins op het huidige niveau te krijgen.
          </p>
          <p>
            Daarom komen Yorick, Jos en Pieter het team van Ludo versterken en
            samen zullen we het aankomende jaar tot een prachtig succes maken!
            Om die reden hebben wij de afgelopen tijd samen gewerkt aan soepele
            overgang, inwerken en toekomstplannen maken.
          </p>
          <p>
            We gaan dit jaar in ieder geval weer het theater in, vernieuwen onze
            Sinterklaasshow en bovendien is het eerste huisbezoek al vastgelegd.
          </p>
          <p>
            Vragen, opmerkingen of zin een gezellig Sinterklaasfeest? We blijven
            bereikbaar via het <b-link to="contact">contactformulier</b-link>,
            <A HREF="mailto:info@ridderendeprins.nl">info@ridderendeprins.nl</A>
            en 06 - 387 94 906.
          </p>
        </b-card-text>
      </b-card>
    </b-col>
    <b-col md="12"> </b-col>
    <b-col md="12">
      <b-card>
        <b-card-title>Fladderen</b-card-title>
        <b-card-text>
          <b-img
            fluid
            align="right"
            class="w-50 cardimage"
            v-bind:src="$imagestore1 + '/website%202018/fladderen.png'"
          />
          <p>
            Voor iedereen die niet uit de omgeving van Houten komt behoeft de
            titel een kleine uitleg.
            <b-link target="_blank" href="https://www.fladderen.nl"
              >Fladderen</b-link
            >
            is een kinderfestijn in Houten in de laatste week van de
            zomervakantie. Een groot deel van de acteurs van Ridder en de Prins
            zijn hier als vrijwilliger actief en zonder het Fladderen zou Ridder
            en de Prins niet zijn wat het nu is.
          </p>
          <p>Daarom zijn wij ook al jaren trotse sponsor van het Fladderen.</p>
          <p>
            Helaas kan het Fladderen dit jaar niet in zijn normale vorm
            doorgaan. Corona is de bekende spelbreker. Maar het Fladderen zou
            het Fladderen niet zijn als er geen creatief alternatief zou zijn!
          </p>
          <p>
            Er zijn verschillende activiteiten bedacht voor in de zomervakantie.
            Wij hebben hier een bijdrage aan mogen leveren. Speciaal voor het
            Fladderen bieden wij onze Jungle Appventure aan. Een uitdagende
            GPS-puzzeltocht. Struin door Houten en verken digitaal de jungle.
            Hoe snel ontdek jij de schat? Start op het Rond, Castellum of het
            Oude Dorp, duur ongeveer 1,5 uur. Leeftijd 8+.
          </p>
          <p>
            Interesse om dit spel op een ander moment, andere locatie of met een
            ander gezelschap te spelen? Neem dan even
            <b-link to="/Contact">contact</b-link> met ons op!
          </p>
        </b-card-text>
      </b-card>
    </b-col>
    <b-col md="12">
      <b-card>
        <b-card-title>Ontwikkelingen</b-card-title>
        <b-card-text>
          <b-img
            fluid
            align="right"
            class="w-50 cardimage"
            v-bind:src="
              $imagestore1 + '/website%202018/Ridder-en-de-Prins--Roetveeg.png'
            "
          ></b-img>
          <p>
            Het is een tijdje stil geweest op onze sociale kanalen. Misschien
            wel te stil. Daarom een korte update over waar wij mee bezig zijn en
            mee bezig zijn geweest.
          </p>
          <p><b>Nieuwe website</b></p>
          <p>
            Alleen met een extreem scherpe blik was het misschien opgevallen dat
            onze website er iets anders uitziet. Des te groter is het verschil
            aan de achterkant van de site. Hugo &amp; Bart hebben hard gewerkt
            om de infrastructuur van de site zo aan te passen zodat de site en
            het Online Grote Boek eenvoudiger te beheren is. Via deze weg
            nogmaals veel dank aan beide heren.
          </p>
          <p>
            <i
              >Mocht je ons nog kunnen attenderen op iets dat nog niet helemaal
              goed werkt krijg je iets extra&rsquo;s in je schoen!</i
            >
          </p>
          <p><b>Roetveeg</b></p>
          <p>
            In het licht van de huidige gebeurtenissen rondom racisme en
            discriminatie vinden wij het belangrijk kritisch naar onze rol en
            visie te kijken. In samenwerking met onze acteurs hebben wij onze
            visie uit 2015 herschreven. Onze visie is
            <b-link to="roetveeg">hier</b-link> te lezen op onze website.
            Behoefte om hierover in gesprek te gaan? Wij waarderen het enorm als
            je contact met ons opneemt.
          </p>
          <p><b>Corona</b></p>
          <p>
            Het Coronavirus en de bijbehorende maatregelen maken dat de komende
            Sinterklaasperiode ook voor ons onzeker is. Wij bereiden achter de
            schermen meerdere scenario&rsquo;s voor en schakelen zo vroeg
            mogelijk met onze klanten. Hoe het Sinterklaasfeest er over 4
            maanden uit komt te zien kan niemand nog voorspellen. Wat wij wel
            zeker weten is dat wij een fantastisch getalenteerd team hebben dat
            er op welke manier dan ook een grandioos feest van gaat maken!
          </p>
        </b-card-text>
      </b-card>
    </b-col>

    <b-col md="12">
      <b-card>
        <b-card-title>Beestenboel</b-card-title>
        <b-card-text>
          <silent-box class="" :image="nieuws[0]"> </silent-box>
          Omdat zoveel kinderen iets komen vertellen over dieren leek het ons
          een goed idee om daar een lied over te schrijven. Dat bracht ons het
          actieve nummer 'Beestenboel' over een buurman die in zijn tuin een
          Dierentuin begint. Van kikkers tot olifanten...wat is die buurman
          cool!
          <b-link target="_blank" href="https://youtu.be/xBomzL-IupU"
            >Beestenboel!</b-link
          >
        </b-card-text>
      </b-card>
    </b-col>
    <b-col md="12">
      <b-card>
        <b-card-title>Ga mee op Jungle Appventure</b-card-title>
        <b-card-text>
          <b-img
            fluid
            align="right"
            class="w-50 cardimage"
            v-bind:src="$imagestore2 + 'listings/m/52.jpg'"
          />
          We hebben een Game App gemaakt! Na anderhalf jaar uitvoerig testen is
          het nu bijna zover. Onze Jungle Appventure komt binnenkort beschikbaar
          in de Appstore en Play Store. Een avonturen spel aan de hand van goed
          nadenken, kijken én lopen. We gebruiken namelijk de GPS om fysieke
          barrieres in te bouwen terwijl het spel verder geheel digitaal is. Je
          gaat op avontuur in in de Jungle, maak een zweep, zoek de boot bij
          elkaar en vaar de rivier op. In de bergen vind je een schat! De
          snelste tijd wint. Interrese om dit met een groep te spelen? Neem
          contact op! info@ridderendeprins.nl
        </b-card-text>
      </b-card>
    </b-col>
    <b-col md="12">
      <b-card>
        <b-card-title>Het Wiebellied, om te wiebelen</b-card-title>
        <b-card-text>
          <silent-box class="" :image="nieuws[1]"> </silent-box>
          We maken al jaren muziek en videoclips. Dit jaar echter kwam de muziek
          uit de koker van een fan. Samen met ons team de tekst en muziek wat
          verbeterd maar uiteraard met groot respect voor wat er al was. Dus met
          veel trots presenteren wij op ons YouTube kanaal
          <b-link href="https://youtu.be/S0V7UpHlM2I" target="_blank"
            >Het Wiebellied!</b-link
          >
          Het Wiebellied, om te wiebelen!
        </b-card-text>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "Nieuws",
  data: function () {
    return {
      nieuws: [
        {
          src: "https://www.youtube.com/embed/xBomzL-IupU",
          // thumbnail: $imagestore2+'listings/o/54.jpg',
          thumbnailWidth: "100%",
        },
        {
          src: "https://www.youtube.com/embed/S0V7UpHlM2I",
          // thumbnail:  "$imagestore2+'listings/m/51.png'",
          thumbnailWidth: "100%",
        },
      ],
    };
  },
};
</script>

<style lang="css" scoped>
#silentbox-gallery {
  width: 50% !important;
  float: right !important;
}
</style>